import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { SideMenuComponent } from "./side-menu.component";
import { DropdownComponent } from "./dropdown/dropdown.component";
import { PermissionsModule } from "../permissions-module/permissions-module";

@NgModule({
  declarations: [SideMenuComponent, DropdownComponent],
  imports: [CommonModule, IonicModule, RouterModule, PermissionsModule],
  exports: [SideMenuComponent, DropdownComponent],
})
export class SideMenuModule {}
